import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const leagueTierDictionary = createSimpleDictionary(
    Array.from({ length: 10 }, (_, i) => ({
        id: i + 1,
        name: String(i + 1),
    })),
    []
);
